'use client';

import Button from '@/components/buttons/Button';
import LogInModal from '@/components/modals/LogInModal';
import { useState } from 'react';

export default function LogInButton() {
  const [showLogInModal, setShowLogInModal] = useState(false);

  return (
    <>
      <Button
        title="Log In"
        onClick={() => setShowLogInModal(true)}
        type="secondary"
      />

      {showLogInModal && (
        <LogInModal onClose={() => setShowLogInModal(false)} />
      )}
    </>
  );
}
